/**
 * A list of all the search query that public search api accepts
 */
export default [
  'term',
  'site',
  'tags',
  'category',
  'platform',
  'compatible_with',
  'colors',
  'sizes',
  'sales',
  'rating_min',
  'price_min',
  'price_max',
  'poly_count',
  'file_formats',
  'item_type',
  'suggest',
  'date',
  'length_min',
  'length_max',
  'tempo',
  'alpha',
  'vocals_in_audio',
  'looped',
  'orientation',
  'requires_plugins',
  'resolution_min',
  'frame_rate',
  'page',
  'page_size',
  'attribute_key',
  'attribute_value',
  'username',
  'sort_by',
  'sort_direction',
  'item_id',
  'metadata',
  'include_pro_affiliated'
]

export const validSortByOptions = [
  'relevance',
  'rating',
  'sales',
  'price',
  'date',
  'updated',
  'category',
  'name',
  'trending'
]

export const validSortDirectionOptions = [
  'asc',
  'desc'
]

export const validDateOptions = [
  'this-year',
  'this-month',
  'this-week',
  'this-day'
]

export const validSizesOptions = [
  'm',
  'l',
  'xl',
  'xxl'
]

export const validOrientationOptions = [
  'landscape',
  'portrait',
  'square'
]



// WEBPACK FOOTER //
// ./common/constants/searchQueryWhitelist.js